/* ADD fitment projects approved canonical mappings for the selected SKU only. */
(() => {
  const unique = values => [...new Set(values)].sort();
  const cleanIds = values => Array.isArray(values) && values.every(value =>
    typeof value === 'string' && value && value.trim() === value && !/[\[\]{};\s]/.test(value));
  const sameIds = (left, right) => cleanIds(left) && cleanIds(right) &&
    JSON.stringify(unique(left)) === JSON.stringify(unique(right));
  const caches = new Map();
  const load = url => {
    if (!caches.has(url)) caches.set(url, fetch(url, {credentials:'same-origin'}).then(response => {
      if (!response.ok) throw new Error('Fitment projection unavailable');
      return response.json();
    }));
    return caches.get(url);
  };
  function resolve(projection, data, selected) {
    const native = (data.variants || []).find(variant => String(variant.id) === String(selected));
    if (!native) return {state:'choose'};
    const product = projection?.products?.[data.productGid];
    const approved = product?.variants?.['gid://shopify/ProductVariant/' + String(selected)];
    if (!projection || projection.schemaVersion !== 'ha-add-approved-fitment.v1' || !projection.authorityDigest ||
        product?.handle !== data.productHandle || approved?.sku !== native.sku ||
        !sameIds(native.fitmentIds || [], approved.fitmentIds || []) ||
        product.universal !== data.universal) return {state:'unavailable'};
    if (approved.state === 'hold') return {state:'hold',sku:native.sku};
    if (approved.state === 'universal' && data.universal === true && !approved.fitmentIds.length)
      return {state:'universal',sku:native.sku};
    if (approved.state !== 'vehicle' || data.universal === true || !approved.applications.length ||
        !sameIds(approved.applications.map(application => application.fitmentId), approved.fitmentIds))
      return {state:'unavailable'};
    return {state:'vehicle',sku:native.sku,applications:approved.applications};
  }
  const element = (tag, text, className) => {
    const node = document.createElement(tag);
    if (text) node.textContent = text;
    if (className) node.className = className;
    return node;
  };
  function selectedId(root, data) {
    const input = root.querySelector('[data-ha-variant-id]');
    if (root.querySelector('[data-ha-variants]') && (!input || input.disabled)) return '';
    return input ? input.value : data.selectedVariantId || '';
  }
  function init(root, prose, dataNode, data) {
    const section = element('section','','product-fitment-details');
    section.setAttribute('data-ha-fitment-details','');
    section.setAttribute('data-ha-add-fitment','');
    section.setAttribute('aria-labelledby','product-fitment-details-heading');
    const heading = element('h2','Fitment for the selected configuration','product-fitment-details__heading');
    heading.id = 'product-fitment-details-heading';
    const status = element('p','Loading vehicle applications…','product-fitment-details__check');
    status.setAttribute('aria-live','polite');
    const content = element('div');
    section.append(heading,status,content);prose.append(section);dataNode.remove();
    let projection = null;
    function render() {
      content.replaceChildren();
      delete section.dataset.selectedSku;
      delete section.dataset.approvedApplications;
      const selected = selectedId(root,data);
      const match = resolve(projection,data,selected);
      if (match.state === 'choose') {
        status.textContent = 'Choose a complete configuration to see its vehicle applications.';return;
      }
      if (match.state === 'hold') {
        status.textContent = 'Vehicle fitment for SKU ' + match.sku + ' requires confirmation before ordering.';return;
      }
      if (match.state === 'unavailable') {
        status.textContent = 'Vehicle fitment is unavailable. Contact us with your vehicle and selected part number before ordering.';return;
      }
      section.dataset.selectedSku = match.sku;
      if (match.state === 'universal') {
        section.dataset.approvedApplications = '0';
        status.textContent = 'SKU ' + match.sku + ' is universal. Check the stated dimensions, mounting points and connections against your setup.';return;
      }
      section.dataset.approvedApplications = String(match.applications.length);
      status.textContent = 'Approved vehicle applications for SKU ' + match.sku + '. Check the conditions shown below.';
      const groups = new Map();
      match.applications.forEach(application => {
        const key = application.make + '\u0000' + application.model;
        if (!groups.has(key)) groups.set(key,{make:application.make,model:application.model,applications:[]});
        groups.get(key).applications.push(application);
      });
      const ordered = [...groups.values()].sort((a,b) => (a.make+' '+a.model).localeCompare(b.make+' '+b.model,'en',{numeric:true}));
      const table = element('div','','product-fitment-table');
      ordered.forEach(group => {
        const details = element('details','','product-fitment-model');details.open = ordered.length <= 3;
        const summary = element('summary','','product-fitment-model__summary');
        summary.append(element('span',group.make+' '+group.model,'product-fitment-model__name'));
        summary.append(element('span','Selected configuration','product-fitment-model__years'));
        summary.append(element('span',String(group.applications.length),'product-fitment-model__count'));
        const toggle = element('span','','product-fitment-model__toggle');toggle.setAttribute('aria-hidden','true');summary.append(toggle);
        const list = element('ul','','product-fitment-applications');
        group.applications.forEach(application => {
          const item = element('li','','product-fitment-application');item.dataset.canonicalId = application.canonicalId;
          item.dataset.fitmentId = application.fitmentId;
          if (application.engineId) item.dataset.canonicalEngineId = application.engineId;
          item.append(element('span',application.label));
          if (application.conditions.length) item.append(element('small',application.conditions.join('. ')));
          list.append(item);
        });
        details.append(summary,list);table.append(details);
      });
      content.append(table);
    }
    root.addEventListener('change',() => queueMicrotask(render));
    window.addEventListener('popstate',() => queueMicrotask(render));
    load(data.addProjectionUrl).then(result => {projection=result;render();}).catch(() => {
      status.textContent = 'Vehicle fitment is unavailable. Contact us with your vehicle and selected part number before ordering.';
    });
  }
  window.hooniesAddProductFitment = {init,resolve,selectedId};
})();
